/* eslint-disable webflow/module-top-level-imports */
import {type AnnotatedExpression} from '@packages/systems/wfdl/annotated-expression/AnnotatedExpressions';
import {
  type ExpressionF,
  _EBoolean,
  _ECall,
  _ECase,
  _EElement,
  _EEnum,
  _EExtend,
  _EFunction,
  _EHole,
  _EList,
  _ELiteral,
  _ENumber,
  _ERecord,
  _ESelect,
  _EText,
  _ETyped,
  _EUnion,
  _EVariable,
  _EData,
  _EDistinct,
} from '@packages/systems/wfdl/GenericExpression/GenericExpressionTypes';
import {
  type CheckerEnvironment,
  type Errors,
} from '@packages/systems/wfdl/Checker/CheckerState';
import {type Type} from '@packages/systems/wfdl/DataTypeDefinition';

export type ContextualExpressionAnnotation = {
  type: null | Type;
  env: CheckerEnvironment;
  errors: Errors;
};
export type ContextualExpression =
  AnnotatedExpression<ContextualExpressionAnnotation>;

export type ContextualExpressionExpr = ExpressionF<ContextualExpression>;

export const ECall = _ECall<ContextualExpression>;
export const EElement = _EElement<ContextualExpression>;
export const ERecord = _ERecord<ContextualExpression>;
export const ESelect = _ESelect<ContextualExpression>;
export const EEnum = _EEnum<ContextualExpression>;
export const EUnion = _EUnion<ContextualExpression>;
export const ECase = _ECase<ContextualExpression>;
export const EList = _EList<ContextualExpression>;
export const EFunction = _EFunction<ContextualExpression>;
export const ETyped = _ETyped<ContextualExpression>;
export const EExtend = _EExtend<ContextualExpression>;
export const EText = _EText<ContextualExpression>;
export const EBoolean = _EBoolean<ContextualExpression>;
export const ENumber = _ENumber<ContextualExpression>;
export const EVariable = _EVariable<ContextualExpression>;
export const ELiteral = _ELiteral<ContextualExpression>;
export const EHole = _EHole<ContextualExpression>;
export const EData = _EData<ContextualExpression>;
export const EDistinct = _EDistinct<ContextualExpression>;
